export const agentRequests = {
  page: {
    filters: {
      accommodation: "Alojamento",
      type: "Tipo",
    },
    subtitle: "O que os teus hóspedes pediram através do agente.",
    clearFilters: "Limpar filtros",
    loadMore: "Ver mais",
    empty: "Ainda não há pedidos.",
    emptyFiltered: "Não há pedidos com estes filtros.",
    columns: {
      type: "Tipo",
      guest: "Hóspede",
      asks: "O que pede",
      channel: "Canal",
      status: "Estado",
      when: "Quando",
      amount: "Valor",
    },
  },
  // La columna Importe: en qué quedó el cobro de cada solicitud.
  amount: {
    paid: "Pago",
    awaiting: "À espera do pagamento",
    property: "A pagar no alojamento",
    void: "Não cobrado",
    quote: "Oferecido",
  },
  common: {
    title: "Solicitações da recepção com IA",
  },
  widget: {
    iaBadge: "IA",
    subtitle: "O que seus hóspedes solicitaram por meio do agente.",
    todayOn: "Mostrando apenas as de hoje",
    todayOff: "Mostrar apenas as solicitações de hoje",
    today: "Hoje",
    entersToday: "Chega hoje",
    entersTodayTitle: "Esta reserva chega hoje",
    test: "teste",
    approve: "Aprovar",
    otherTime: "Outro horário",
    prioritize: "Priorizar",
    reject: "Recusar",
    dismiss: "Dispensar do painel",
    loading: "Carregando solicitações…",
    empty: "Nenhuma solicitação ainda.",
    emptySub: "Quando um hóspede solicitar um check-out tardio, check-in antecipado ou noites extras, aparecerá aqui.",
    viewAll: "Ver todas as solicitações",
    entryTime: "Horário do check-in",
    cancel: "Cancelar",
    rejectIrreversible: "Esta ação não pode ser desfeita.",
    modal: {
      approveTitle: "Aprovar a solicitação?",
      approveTimeTitle: "Aprovar em outro horário?",
      tentativeTitle: "Priorizar esta chegada?",
      rejectTitle: "Recusar a solicitação?",
      defaultTitle: "Confirmar?",
      approveText: "Você está prestes a aprovar o check-in antecipado de",
      approveTimeText: "Você confirmará o check-in no horário que definir para",
      tentativeText: "Vamos dizer que vocês farão todo o possível para deixar tudo pronto nesse horário, mas que depende da saída anterior e da limpeza. Será enviado para",
      rejectText: "Você está prestes a recusar o check-in antecipado de",
      defaultText: "Confirmar para",
      approveCta: "Sim, aprovar",
      approveTimeCta: "Confirmar horário",
      tentativeCta: "Sim, notificar",
      rejectCta: "Sim, recusar",
      defaultCta: "Confirmar",
    },
  },
  drawer: {
    close: "Fechar",
    allAccommodations: "Todas as acomodações",
    allTypes: "Todos os tipos",
    today: "Hoje",
    yesterday: "Ontem",
    from: "De",
    to: "Até",
    clear: "Limpar",
    writeWhatsapp: "Mensagem no WhatsApp",
    noMessages: "Nenhuma mensagem salva para esta conversa.",
    pause: "Pausar",
    play: "Reproduzir",
    downloadMp3: "Baixar MP3",
    viewReservation: "Ver reserva",
    loading: "Carregando…",
    emptyFiltered: "Nenhuma solicitação corresponde a estes filtros.",
    end: "Não há mais solicitações.",
    features: {
      early: "Check-in antecipado",
      late: "Check-out tardio",
      extend: "Estender estadia",
      invoice: "Fatura",
      handoff: "Ação necessária",
      callMessage: "Recados de chamadas",
    },
    channels: {
      call: "Ligação",
    },
  },
  box: {
    rooms: "{count} quarto | {count} quartos",
    nights: "{count} noite | {count} noites",
    guests: "{count} hóspede | {count} hóspedes",
    earlyRequestedTitle: "Check-in antecipado solicitado",
    arrivalRequestedTitle: "Horário de chegada solicitado",
    early: "Antecipado",
    arrives: "Chega",
  },
};
